(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["icontactic-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Step illustrations ship fully drawn. With IntersectionObserver we arm them (hidden strokes) and draw once when 20% is on screen; never un-draw on scroll-out.
    var anims = document.querySelectorAll('[data-ict-anim] svg.cr-anim');
    if (!anims.length || !('IntersectionObserver' in window)) { return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.2 });
    anims.forEach(function (s) { s.classList.add('cr-armed'); io.observe(s); });
  })();
  document.querySelectorAll('[data-ict-tabs]').forEach(function (root) {
    var tabs = root.querySelectorAll('[data-ict-tab]');
    var panels = root.querySelectorAll('[data-ict-panel]');
    var warmed = false;
    var warm = function () {
      if (warmed) { return; }
      warmed = true;
      root.querySelectorAll('[data-ict-panel] img[loading="lazy"]').forEach(function (img) { img.setAttribute('loading', 'eager'); });
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { warm(); io.disconnect(); }
      }, { rootMargin: '900px 0px' });
      io.observe(root);
    }
    root.addEventListener('pointerenter', warm, { once: true });
    root.addEventListener('touchstart', warm, { once: true, passive: true });
    root.addEventListener('focusin', warm, { once: true });
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = tab.getAttribute('data-ict-tab');
        tabs.forEach(function (t) { var on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
        panels.forEach(function (p) { var on = p.getAttribute('data-ict-panel') === idx; p.classList.toggle('is-active', on); if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); } });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
